// "Production" enabled environment

export const environment = {
    production: true,
    hmr: false,
    appConfig: 'appconfig.production.json',
    remoteServiceBaseUrl: "https://api.travelm8express.asia",
    appBaseUrl: "https://www.travelm8express.asia/",
    apiUrl: "https://api.travelm8express.asia",
};
